export default __webpack_public_path__ + "static/media/blur-homepage-category.82fa4918.png";